import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const OneIcon: React.FC<IconSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="101" viewBox="0 0 45 101" fill="none" {...props}>
    <path d="M18.6301 100.561V18.0956L24.6575 22.7531H0V0.56134H44.1096V100.561H18.6301Z" fill={props.color} />
  </svg>
)
